import { render, staticRenderFns } from "./Leases.vue?vue&type=template&id=289de70d&scoped=true&"
import script from "./Leases.vue?vue&type=script&lang=js&"
export * from "./Leases.vue?vue&type=script&lang=js&"
import style0 from "./Leases.vue?vue&type=style&index=0&id=289de70d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289de70d",
  null
  
)

export default component.exports